import { APIClient } from '@/infrastructure/network/Monitaro/APIClient'

export class MonitaroGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
